import { computed } from 'vue'
import { Company, PreAuthCompany, User, userTypes } from './authTypes'
import { AuthState } from './authState'
import { Route } from '@/composables/useRouter'
import { checkIsMobile } from '@/helpers/navigator'

export function createGetters(state: AuthState) {
  const loading = computed(() => state.loadingRef.value)
  const error = computed(() => state.errorData.value)

  const preAuthToken = computed((): string => state.preAuthData.value?.preAuthToken as string)
  const companies = computed((): PreAuthCompany[] => state.preAuthData.value?.companies as PreAuthCompany[])
  const isMultiCompany = computed((): boolean => (companies.value ?? []).length > 1)
  const hasCompanies = computed((): boolean => (companies.value ?? []).length > 0)

  const isDFAUser = computed((): boolean => !!state.preAuthData.value.redirectUrl)
  const DFAUrl = computed((): string => state.preAuthData.value?.redirectUrl as string)

  const accessToken = computed((): string => state.authData.value?.accessToken)
  const refreshToken = computed((): string => state.authData.value?.refreshToken)
  const user = computed((): User => state.authData.value?.user)
  const fullName = computed((): string => `${user.value?.name || ''}`)
  const isUserLogged = computed((): boolean => !!state.authData.value?.accessToken)
  const isDMSUser = computed((): boolean => user.value?.type === userTypes.DMS)
  const isLexonUser = computed((): boolean => user.value?.type === userTypes.LEXON)
  const isCustomerPortal = computed((): boolean => user.value?.type === userTypes.CUSTOMER_PORTAL)
  const isFactureUser = computed((): boolean => user.value?.type === userTypes.FACTURE)
  const isMobileUser = computed((): boolean => user.value?.type === userTypes.LEXON && checkIsMobile())

  const getPermissions = computed((): any => user.value?.permissions)

  const encryptedUserId = computed((): string => user.value?.encryptedUserId)

  const company = computed((): Company => user.value?.company)

  const nextUrl = computed((): Route => state.nextUrlData.value)
  const isNextUrl = computed((): boolean => !!nextUrl.value && Object.keys(nextUrl.value).length > 0)

  return {
    error,
    loading,
    preAuthToken,
    companies,
    isMultiCompany,
    hasCompanies,
    isDFAUser,
    DFAUrl,
    accessToken,
    refreshToken,
    user,
    isUserLogged,
    isDMSUser,
    isCustomerPortal,
    isLexonUser,
    isFactureUser,
    isMobileUser,
    fullName,
    company,
    nextUrl,
    isNextUrl,
    encryptedUserId,
    getPermissions
  }
}

export type AuthGetters = ReturnType<typeof createGetters>
